import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Translate from '../layout/Translate';
import {monthsPeriod} from '../../api/monthsPeriod';
import Price from '../layout/Price';

export default class TourSearchPreview extends Component {


    componentWillMount() {

        if (this.props.tour.months && this.props.tour.months.length) {
            if (this.props.tour.months.length == 12) {
                this.period = ['Круглый год', 'Круглый год']
            } else {
                this.period = monthsPeriod(this.props.tour.months, this.props.lang);
            }
        } else {
            this.period = ['', '']
        }


    }
    rating (numrows) {
        var rows = [];
        for (var i=1; i < numrows+1; i++) {
            rows.push(<div className="rate__star"></div>);
        }
        return rows;
    }

    nextTour() {
        this.props.nextTour()
    }
    selectTour() {
        this.props.selectTour(this.props.tour);
        this.props.fetchReviews(this.props.tour.id);
        this.props.loadTour(1, this.props.tour.id);
        this.props.toggleMenu(true);
    }

    getNumEnding(iNumber, aEndings)
    {
        var sEnding, i;
        iNumber = iNumber % 100;
        if (iNumber>=11 && iNumber<=19) {
            sEnding=aEndings[2];
        }
        else {
            i = iNumber % 10;
            switch (i)
            {
                case (1): sEnding = aEndings[0]; break;
                case (2):
                case (3):
                case (4): sEnding = aEndings[1]; break;
                default: sEnding = aEndings[2];
            }
        }
        return sEnding;
    }

    render () {

        let endings = [<Translate slug="tour__day-1" />, <Translate slug="tour__day-2-4" />, <Translate slug="tour__day-5-0" />];

        const { tour } = this.props;

        return (


            
                        <Link to={(tour.is_archived?"/tours/archive/":"/tours/") + (this.props.tour.id)}  className="results__item result" onClick={this.selectTour.bind(this)}>
                            <div className="result__photo" style={{backgroundImage: 'url('+ ((tour.coverImages && tour.coverImages.previews)?tour.coverImages.previews.browsing1000:'') +')'}}></div>
                            <div className="result__info">
                                <h2 className="result__title">{tour.title}</h2>
    
                                <div className="result__summary">
                                    <div className="tours__summary-info">{tour.days_count} <span className="tours__uppercase-label">{this.getNumEnding(tour.days_count, endings)}</span></div>
                                    {this.period &&
                                    <div className="tours__summary-info"><span
                                        className="tours__uppercase-label">{this.period[0]}</span>
                                        {this.period[0] != this.period[1] &&
                                        <span> - <span className="tours__uppercase-label">{this.period[1]}</span></span>
                                        }
                                    </div>
                                    }
                                    <div className="clearfix"></div>
                                    <div className="tours__summary-info ">

                                        <div className="rate-search__row">
                                            <div className="rate-search__label"><Translate slug="tour__complexity" /></div>
                                            <div className="rate-search__label"><Translate slug="tour__service" /></div>
                                        </div>

                                        <div className="rate-search__row">
                                            <div className="rate-search">
                                                {this.rating(5).map((point, i) =>
                                                    <div key={i} className={"rate-search__star " + (tour.complexity_rate > i ? 'rate-search__star_active' : '')}></div>
                                                )}
                                            </div>
                                            <div className="rate-search">
                                                {this.rating(3).map((point, i) =>
                                                    <div key={i} className={"rate-search__star " + (tour.service_rate > i ? 'rate-search__star_active' : '')}></div>
                                                )}
                                            </div>
                                        </div>


    
                                    </div>
                                </div>
                            </div>
                                <div className="result__price">

                                    {!!parseFloat(tour.min_price) &&
                                        <Price price={tour.min_price} currency={((tour.currency_id)?tour.currency_id:'RUR')} />
                                    }
                                    {tour.type &&
                                        <span className="result__type"><span className="result__type_required">{tour.type}</span>nature</span>
                                    }
                                </div>
                    </Link>




        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/tours/SearchPreview.js